<template>
    <div class="salepage-sidebar tw-w-full">
        <div>
            <div class="salepage_sidebar--topbar tw-text-xl tw-font-bold"
                :style="`background-color: ${salepage.menu_color}; color: ${salepage.menu_text}`">
                <i class="fa fa-bars tw-cursor-pointer tw-mr-2" @click="isOpen = true" v-if="menus.length > 0"></i>
                {{ salepage.title }}
            </div>
            <div class="salepage_sidebar--shade" v-if="isOpen" @click="isOpen = false"></div>

            <div class="salepage_sidebar--sidebar"
                :style="isOpen ? 'transform: translateX(100%);' + `background-color: ${salepage.menu_color}; color: ${salepage.menu_text}` : ''">
                <div class="p-2">

                    <div class="tw-flex tw-justify-between border-b">

                        <div class="tw-text-xl tw-font-bold tw-self-center tw-px-2">
                            {{ salepage.title }}
                        </div>

                        <button class="btn btn-sm salepage_sidebar--button" :style="styleObject">
                            <i class="fa fa-arrow-left fa-2x tw-cursor-pointer" @click="isOpen = false"></i>
                        </button>

                    </div>
                    <hr />

                    <div class="tw-grid tw-grid-cols-1 tw-gap-2 tw-mt-4">

                        <div v-for="(menu, index) in menus" :key="index" class="tw-full">
                            <div v-if="menu.link_type != 'external'">
                                <a 
                                    class="btn salepage_sidebar--button tw-text-left tw-w-full tw-p-2 tw-rounded"
                                    v-if="menu.link_type != 'home'"
                                    :style="styleObject"
                                    :href="`${salepage.domain_url ? '/' : api_url + '/' +salepage.slug}?preMenu=${menu.id}`"
                                >
                                    <i :class="`fa ${menu.link.icon} mr-2`"></i>
                                    {{ menu.title }}
                                </a>
                                <a
                                    class="btn salepage_sidebar--button tw-text-left tw-w-full tw-p-2 tw-rounded"
                                    v-else
                                    :style="styleObject"
                                    :href="`${salepage.domain_url ? '/' : api_url + '/' + salepage.slug}`"
                                >
                                    <i class="fa fa-home mr-2"></i>
                                    {{ menu.title }}
                                </a>
                            </div>
                            <div v-else>
                                <a :href="`https://${menu.link}`" target="_blank"
                                    class="btn salepage_sidebar--button tw-text-left tw-w-full tw-p-2 tw-rounded"
                                    :style="styleObject"    
                                >
                                    <i class="fa fa-external-link mr-2"></i>
                                    {{ menu.title }}
                                </a>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
export default {
    props: ["salepage", "menus", "base_url"], 
    data() {
        return {
            api_url: this.base_url,
            isOpen: false,
        }
    }, methods: {
        closeSidebar() { this.isOpen = false; }
    }, computed: {
        styleObject: function () {
            return {
                '--button-color': this.salepage.menu_text,
                '--button-background-color-hover': this.salepage.menu_text,
                '--button-border-color-hover': this.salepage.menu_color,
                '--button-color-hover': this.salepage.menu_color,
            }
        }
    }
}
</script>

<style scoped>
a {
    color: inherit;
    text-decoration: none;
}

.salepage_sidebar--topbar {
    position: fixed;
    width: 100%;
    padding: 10px 20px;
    top: 0;
    left: 0;
    z-index: 9997;

}

.salepage_sidebar--shade {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
    z-index: 9998;
}

.salepage_sidebar--sidebar {
    position: fixed;
    top: 0;
    left: -20%;
    width: 20%;
    height: 100%;
    background-color: #fff;
    z-index: 9999;
    transition: all 0.5s ease;
    transform: translateX(0);
}

.salepage_sidebar--button {
    color: var(--button-color);
}

.salepage_sidebar--button:hover {
    background-color: var(--button-background-color-hover);
    color: var(--button-color-hover);
    border-color: var(--button-border-color-hover);
}

@media only screen and (max-width: 640px) {
    .salepage_sidebar--sidebar {
        position: fixed;
        top: 0;
        left: -80%;
        width: 80%;
        height: 100%;
        background-color: #fff;
        z-index: 9999;
        transition: all 0.5s ease;
        transform: translateX(0);
    }
}

@media only screen and (max-width: 768px) and (min-width: 641px) {
    .salepage_sidebar--sidebar {
        position: fixed;
        top: 0;
        left: -75%;
        width: 75%;
        height: 100%;
        background-color: #fff;
        z-index: 9999;
        transition: all 0.5s ease;
        transform: translateX(0);
    }
}

@media only screen and (max-width: 1024px) and (min-width: 769px) {
    .salepage_sidebar--sidebar {
        position: fixed;
        top: 0;
        left: -35%;
        width: 35%;
        height: 100%;
        background-color: #fff;
        z-index: 9999;
        transition: all 0.5s ease;
        transform: translateX(0);
    }
}
</style>
